<template>
    <div class="admin__preferences">
        <h5 class="admin__preferences-title"><i class="far fa-cog"></i> Opt-Out Form Preferences</h5>
        <form id="preferencesSCI">
            <div class="row">
                <div class="col-xl-10">
                    <p class="admin__preferences-subtitle">Configure the preferences for the Opt-Out form</p>
                    <div class="row mb-3">
                        <div class="col-lg-5">
                            <div class="form-group mb-0">
                                <label class="my-auto mr-2">
                                    <i class="far fa-calendar-alt"></i> Automated Date
                                </label>
                                <input type="radio" id="formState" name="formState" value="automated"
                                    v-model="formState" @change="setPreferences($event)">
                            </div>
                            <p v-if="!startDate || !endDate" class="text-primary mb-1">
                                <i class="far fa-info-circle mr-1"></i> <b>Important:</b> A start date and end date must
                                be specified in order to automatically open and close the form.
                            </p>
                        </div>
                        <div class="col-lg-7">
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <label class="input-group-text label__date" for="startDate"> <i
                                            class="far fa-calendar-check mr-1"></i> Start Date</label>
                                </div>
                                <input type="date" class="form-control" id="startDate" ref="startDate" name="startDate"
                                    v-model="startDate" placeholder="Start Date" aria-label="Start date"
                                    @change="setDate($event)" :disabled="!(formState === 'automated')">
                                <small class="text-muted w-100">Date format: MM-DD-YYYY</small>
                            </div>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <label class="input-group-text label__date" for="endDate"> <i
                                            class="far fa-calendar-times mr-1"></i> End Date</label>
                                </div>
                                <input type="date" class="form-control" id="endDate" ref="endDate" name="endDate"
                                    v-model="endDate" placeholder="End Date" aria-label="End date"
                                    @change="setDate($event)" :disabled="!(formState === 'automated')">
                                <small class="text-muted w-100">Date format: MM-DD-YYYY</small>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-5">
                            <div class="form-group mb-0">
                                <label class="mr-2">
                                    <i v-if="manualState ==='on'" class="far fa-toggle-on"></i> <i v-else
                                        class="far fa-toggle-off"></i> Manual
                                </label>
                                <input type="radio" id="formState" name="formState" value="manual" v-model="formState"
                                    @change="setPreferences($event)">
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div class="form-group">
                                <select class="form-control form-control-sm" id="manualState" name="manualState"
                                    v-model="manualState" :disabled="!(formState === 'manual')"
                                    @change="setPreferences($event)">
                                    <option value="on">On</option>
                                    <option value="off">Off</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-lg-5">
                            <div class="form-group mb-0">
                                <label class="my-auto mr-2">
                                    <i class="far fa-user-lock"></i> Restricted
                                </label>
                                <input type="radio" id="formState" name="formState" value="restricted"
                                    v-model="formState" @change="setPreferences($event)">
                            </div>
                            <p class="text-primary mb-1">
                                <i class="far fa-info-circle mr-1"></i> <b>Important:</b> Each user must be comma
                                seperated (ex. user1, user2).
                            </p>
                        </div>
                        <div class="col-lg-7">
                            <div class="form-group mb-2">
                                <textarea class="form-control form-control-sm" id="restrictedUsers"
                                    name="restrictedUsers" ref="restrictedUsers" v-model="restrictedUsers"
                                    value="restrictedUsers" placeholder="Add users by username or email"
                                    :disabled="!(formState === 'restricted')" rows="3"></textarea>
                            </div>
                            <button type="button" class="btn btn-sm btn-primary float-right"
                                :disabled="!(formState === 'restricted')" @click="setRestrictedUsers()"><i
                                    v-if="!submit" class="far fa-edit"></i>
                                <i v-else class="far fa-spinner fa-spin"></i> Set Users</button>
                        </div>
                    </div>
                    <div class="text-right">
                        <transition name="fade">
                            <h6 v-if="alert==='success'" class="text-success">
                                <i class="far fa-check"></i> Opt-Out form preferences has been
                                updated!
                            </h6>
                            <h6 v-else-if="alert==='warning'" class="text-warning">
                                <i class="far fa-info"></i> An error occured during the update process. <b>Please contact your system administrator.</b>
                            </h6>
                        </transition>
                    </div>
                </div>
                <div class="col-xl-2">
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {
    setTimeout,
    clearInterval
} from 'timers';

export default {
    name: 'admin-preferences',
    props: {
        preferences: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            alert: '',
            alertTimeout: '',
            endDate: '',
            formState: '',
            manualState: '',
            restrictedUsers: '',
            submit: false,
            startDate: '',
        }
    },
    methods: {
        getDateRange() {
            // Set start date preferences
            if (this.preferences && this.preferences.startDate) {
                this.startDate = this.preferences.startDate;
                this.$refs.endDate.min = this.startDate;
            }

            // Set end date preferences
            if (this.preferences && this.preferences.endDate) {
                this.endDate = this.preferences.endDate;
            }
        },
        getFormState() {
            // Set default state if preference does not exist
            if (!this.preferences.formState) {
                this.formState = 'manual';
            } else {
                this.formState = this.preferences.formState;
            }
        },
        getManualState() {
            // Set default state if preference does not exist
            if (!this.preferences.manualState) {
                this.manualState = 'off';
            } else {
                this.manualState = this.preferences.manualState;
            }
        },
        getRestrictedUsers() {
            // Set default restricted users if preference does not exist
            if (this.preferences.restrictedUsers) {
                this.restrictedUsers = this.preferences.restrictedUsers;
            }
        },
        setDate(event) {
            // Set min date
            this.$refs.endDate.min = this.startDate;

            // Date range verification
            let startDate = new Date(this.startDate);
            let endDate = new Date(this.endDate);

            if (startDate.getTime() > endDate.getTime()) {
                this.endDate = this.startDate;
            }

            // Set preferences
            this.setPreferences(event);
        },
        setPreferences(event) {
            const that = this;
            const formData = new FormData();
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminPrefsSet';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Add key value pair to formdata
            if (event.target.id.match(/date$/i)) {
                // Add start and end date
                formData.append(this.$refs.startDate.id, this.startDate);
                formData.append(this.$refs.endDate.id, this.endDate);
            } else {
                formData.append(event.target.id, event.target.value);
            }

            // POST request set preferences
            fetch(URL, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Result handler
                    if (json.result.match(/OK/i)) {
                        // Success alert
                        that.alert = 'success';
                    } else {
                        // Error alert
                        that.alert = 'warning';
                    }

                    // Retrieve preferences
                    that.$emit('getPreferences');
                })
                .catch(function () {
                    // Error alert
                    that.alert = 'warning';
                })

            // Alert timeout
            if (!that.alertTimeout) {
                that.alertTimeout = setTimeout(function () {
                    that.alert = '';
                    clearInterval(that.alertTimeout);
                    that.alertTimeout = '';
                }, 5000);
            }
        },
        setRestrictedUsers() {
            const that = this;
            const formData = new FormData();
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminPrefsSet';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Add key value pair to formdata
            if (this.$refs.restrictedUsers) {
                // Add restricted users form data
                formData.append(this.$refs.restrictedUsers.id, this.$refs.restrictedUsers.value);

                // Set submit flag
                that.submit = true;

                // POST request set preferences
                fetch(URL, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (json) {
                        // Remove submit flag
                        that.submit = false;

                        // Result handler
                        if (json.result.match(/OK/i)) {
                            // Success alert
                            that.alert = 'success';
                        } else {
                            // Error alert
                            that.alert = 'warning';
                        }

                        // Retrieve preferences
                        that.$emit('getPreferences');
                    })
                    .catch(function () {
                        // Remove submit flag
                        that.submit = false;

                        // Error alert
                        that.alert = 'warning';
                    })

            } else {
                // Remove submit flag
                that.submit = false;

                // Error alert
                that.alert = 'warning';
            }

            // Alert timeout
            if (!that.alertTimeout) {
                that.alertTimeout = setTimeout(function () {
                    that.alert = '';
                    clearInterval(that.alertTimeout);
                    that.alertTimeout = '';
                }, 5000);
            }
        }
    },
    mounted() {
        // Set form state
        this.getFormState();

        // Set automated dates
        this.getDateRange();

        // Set manual state
        this.getManualState();

        // Set restricted users
        this.getRestrictedUsers();
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.alertTimeout);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.alertTimeout);
    }
}
</script>

<style scoped>
.admin__preferences {}

.admin__preferences-title {
    color: #455a64;
    font-weight: 400;
}

.admin__preferences-subtitle {
    font-weight: 300;
    margin-bottom: 15px;
    color: #99abb4;
}

.label__date {
    width: 112px;
}
</style>